/** Shopify CDN: Minification failed

Line 92:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 93:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 103:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 104:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 108:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 113:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 119:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 125:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 129:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 136:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 8 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 77:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 78:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 88:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 89:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 93:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 98:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 104:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 110:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 114:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 121:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 8 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 62:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 63:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 73:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 74:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 78:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 83:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 89:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 95:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 99:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 106:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 8 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 47:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 48:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 58:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 59:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 63:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 68:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 74:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 80:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 84:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 91:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 8 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 32:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 33:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 44:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 48:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 53:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 59:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 65:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 69:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 76:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 8 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 17:47 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 18:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 28:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 29:6 Transforming let to the configured target environment ("es5") is not supported yet
Line 33:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 38:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 44:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 50:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 54:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 61:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 8 more hidden warnings

**/
if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if(!this.hasAttribute('available')) return;

      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        document.querySelector('pickup-availability-drawer').show(evt.target);
      });
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.onBodyClick = this.handleBodyClick.bind(this);

      this.querySelector('button').addEventListener('click', () => {
        this.hide();
      });

      this.addEventListener('keyup', (event) => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
        this.hide();
      }
    }

    hide() {
      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.body.addEventListener('click', this.onBodyClick);
      document.body.classList.add('overflow-hidden');
      trapFocus(this);
    }
  });
}
